export type UsePageTitleHook = ReturnType<typeof usePageTitle>;
const usePageTitle = () => {
  const setPageTitle = (title: string) => {
    document.title = `${title} | StatMgr`;
  };

  return { setPageTitle };
};

export default usePageTitle;
